var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__more_button"},[_c('button',{staticClass:"btn btn--small btn--tertiary btn--border",attrs:{"type":"button","id":"filter-more-button-more"},on:{"click":function($event){return _vm.$emit('switch-menu')}}},[_vm._v(_vm._s(_vm.$t(_vm.filter.moreMenu.buttons.moreFilters)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }